import React, {useRef, useState} from 'react';
import {useHistory} from 'react-router-dom'
import Toolbox from './Toolbox';
import GridLineStyle from '../components/Ruler/GridLineStyle';
import Editor from './Editor/Editor';
import ElementProps from './ElempentProps';
import ModalDialog from './ModalDialog/ModalDialog'
import ModalDialogFile from './ModalDialog/ModalDialogFile'
import ModalDialogDoc from './ModalDialog/ModalDialogDoc'
import ModalDialogPage from './ModalDialog/ModalDialogPage'
import ModalDialogData from './ModalDialog/ModalDialogData'
import {useAlert} from '../react-alert-master/src'
import objeler from './objeler';
import $ from 'jquery';
import ToolboxFileExplorer from './ToolboxFileExplorer';
import axios from 'axios';
import {GetNewFileName} from './Functions/funcs';
import {ControlledMenu, MenuDivider, MenuItem, SubMenu} from '../react-menu/dist'
import '../react-menu/dist/index.css';
import '../react-menu/dist/transitions/slide.css';
import store from "../redux/store";
import axiosInstance from "./token/axiosInstance";

type Props = {
    tools: [],
    activeElement: {
        properties: {}
    },
    scaleNumber: Number
};

const btnMenuItemClass = ' text-gray-600  hover:bg-blue-50    ';
const btnSubMenuItemClass = ' text-gray-600  hover:bg-blue-50  focus:text-gray-600 ';
const btnMenuTextClass = "text-sm text-gray-600";
const btnSubMenuClass = ' text-gray-600  bg-customWhite  hover:bg-blue-50  ';
const btnMenuIconSize = "1.1em";
const btnMenuIconWidth = "23px";
const btnMenuIconWidthPdf = "100%";
var counter
const btnMenuClass = 'inline-block bg-white  text-sm px-4 py-2 leading-none border rounded  text-gray-600 border-gray-600 hover:border-transparent  hover:bg-blue-500 hover:bg-text-red mt-1 lg:mt-2 ';
export default function Container(props: Props) {
    const alert = useAlert()
    const [ContextMenuState, setContextMenuState] = useState('closed');
    const [disconnectCount, setDisconnectCount] = useState(0);
    // const [counter, setCounter] = useState(0);
    const [AnchorPoint, setAnchorPoint] = useState({x: 0, y: 0});
    const [MenuActionPageId, setMenuActionPageId] = useState(null);
    const history = useHistory();
    const disconnectWarn = window.GET_ENV(process.env.REACT_APP_DISCONNECT_WARN)

    function useOnceCall(cb, condition = true) {
        const isCalledRef = React.useRef(false);
        React.useEffect(() => {

            setTimeout(function() {
                window.addEventListener('unload', onClose);
            }, 1000);

            if (condition && !isCalledRef.current) {
                isCalledRef.current = true;
                cb();
            }


        }, [cb, condition]);
    }
    const onClose = () =>{
        axiosInstance.post(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/login/Logout', null
            , {
                // headers: {Authorization: `Bearer ${objeler.User.Token.AccessToken}`},
                //responseType: 'arraybuffer'
            }
        ).then((response) => {
            console.log('RES',response,store.getState().appReducers.SessionId)
            if (response.data==='dublicate'){
                sessionStorage.clear();
                objeler.User = null;
                history.push({
                    pathname: '/'
                    , state: {redir: true}
                })
            }

        }).catch((error) => {

            sessionStorage.clear();
            objeler.User = null;
            history.push({
                pathname: '/'
                , state: {redir: true}
            })
        })
        }

    useOnceCall(() => {

        GetFiles();
        // setInterval(() => {
        //     checksession();
        // }, 6000);
        startTimer()

        return () => clearInterval(interval);
    })
    const settimer = () => {
        console.log('TIMER', timer)
        setTimer(timer + 1)

    }
    const startTimer = async () => {
        const interval = setInterval(() => {
            // setCounter((prevCounter) => prevCounter + 1);
            let counter = sessionStorage.getItem("counter")
            if (counter === null)
                counter = 0
            let s = parseInt(counter) + 1
            sessionStorage.setItem("counter", s.toString());
        }, 5000);
        sessionStorage.setItem("i", interval)
    }

    const checksession = async () => {
        //console.log('checkdb', objeler.hasOwnProperty("User"), objeler.User);
        if (!objeler.hasOwnProperty("User")) return

        console.log('checkdb', window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/login/checksession')

        await axiosInstance.post(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/login/checksession', null
            , {
                // headers: {Authorization: `Bearer ${objeler.User.Token.AccessToken}`},
                //responseType: 'arraybuffer'
            }
        ).then((response) => {
            console.log('RES', response, store.getState().appReducers.SessionId)
            if (response.data === 'NoResponse')
                throw new Error(response.data);

            if (response.data === 'dublicate') {
                // alert.success([{type: "error", msg: "Another session is opened.This session has been closed."}]);
                checksessionStopTimer()
                alert.success("Another session is opened.This session will be closed. Do you want to end the session?", true
                    , {
                        title: "Warning",
                        closeCopy: "Cancel",
                        width: '415px',
                        close: () => {
                            startTimer()
                            GetSession()
                        },
                        actions: [
                            {
                                copy: "OK",
                                onClick: () => {
                                    LostOk()
                                },
                            }
                        ]
                    }
                );
                console.log('CANCEL')
                // sessionStorage.clear();
                // objeler.User = null;
                // history.push({
                //     pathname: '/'
                //     , state: {redir: true}
                // })
            }
            if (response.data === 'timeout') {
                // alert.success([{type: "error", msg: "Another session is opened.This session has been closed."}]);
                checksessionStopTimer()
                alert.success("The session was terminated due to a timeout.", true
                    , {
                        title: "Warning",
                        closeCopy: "OK",
                        close: () => {
                            LostOk()

                        },
                        // actions: [
                        //     {
                        //         copy: "OK",
                        //         onClick: () => {
                        //             LostOk()
                        //         },
                        //     }
                        // ]
                    }
                );

            }
        }).catch((error) => {
            console.log('catch', error,disconnectWarn)
            setDisconnectCount(disconnectCount + 1)
            if (disconnectCount > disconnectWarn) {
                setDisconnectCount(0)
                checksessionStopTimer()
                alert.success("Disconnected. Would you like to try again?", true
                    , {
                        title: "Warning",
                        closeCopy: "Cancel",
                        close: () => {
                            LostOk()
                        },
                        actions: [
                            {
                                copy: "OK",
                                onClick: () => {
                                    startTimer()
                                },
                            }
                        ]
                    }
                );

            }
        })


    }
    const LostOk = () => {
        checksessionStopTimer()
        sessionStorage.clear()
        objeler.User = null;
        history.push({
            pathname: '/'
            , state: {redir: true}
        })
    }
    const GetSession = () => {
        if (!objeler.hasOwnProperty("User")) return

        console.log('checkdb', window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/login/getsession')
        axiosInstance.post(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/login/getsession', null
            , {
                // headers: {Authorization: `Bearer ${objeler.User.Token.AccessToken}`},
                //responseType: 'arraybuffer'
            }
        ).then((response) => {
            console.log('RES', response, store.getState().appReducers.SessionId)

        }).catch((error) => {
            //alert.success([{type: "error", msg: "Connection lost."}]);
            sessionStorage.clear();
            objeler.User = null;
            history.push({
                pathname: '/'
                , state: {redir: true}
            })
        })
    }
    const RefreshFileExplorer = () => {
        GetFiles();
    }
    const ShowLoaderAllClose = () => {
        props.ShowLoader(false, ['']);
        setshowLoaderFile(false);
    }
    const DeleteFile = (e) => {
        var username = "";
        var password = "";
        try {
            username = objeler.User.Email;
            password = objeler.User.password;
        } catch {
            return;
        }
        setshowLoaderFile(true);
        const url = window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/wdc/deletefile/' + username + '/' + e;
        axiosInstance.get(url,
            {
                // headers: {Authorization: `Bearer ${objeler.User.Token.AccessToken}`}
            }
        ).then(resp => {
            RefreshFileExplorer();
        }).catch((err) => {
            console.log('rrrr', err)
        });
    }
    const GetFiles = () => {
        var username = "";
        var password = "";
        try {
            username = objeler.User.Email;
            password = objeler.User.password;
        } catch {
            return;
        }
        setshowLoaderFile(true);
        const url = window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/wdc/GetFiles2/' + username;
        axiosInstance.get(url,
            {
                // headers: {Authorization: `Bearer ${objeler.User.Token.AccessToken}`}
            }
        ).then(resp => {
            console.log('📁 GetFiles2 Response:', resp.data);
            console.log('📁 userfiles raw:', resp.data.userfiles);
            console.log('📁 userfiles type:', typeof resp.data.userfiles);
            
            var userFiles = [];
            if (resp.data.userfiles && resp.data.userfiles !== "undefined") {
                try {
                    userFiles = JSON.parse(resp.data.userfiles);
                    console.log('📁 Parsed userFiles:', userFiles);
                } catch (e) {
                    console.log('❌ Error parsing user files:', e);
                    userFiles = [];
                }
            } else {
                console.log('⚠️ No userfiles in response or userfiles is undefined');
            }
            
            objeler["userFiles"] = userFiles;
            if (objeler.ModalFileParameters.IsNew == 1) {
                objeler["DocName"] = GetNewFileName();
                objeler.ChangeDocName(objeler.DocName);
            }
            setUserFiles(userFiles);
            setshowLoaderFile(false);
            objeler.SearchBarRefresh();
        }).catch((err) => {
            console.log('❌ Error loading user files:', err)
        });
    }
    $('#ceren').one('wheel ', function (e) {
        if (e.shiftKey) {
            e.preventDefault()
        }
    })
    const tarik = useRef([])
    const ceren = React.createRef(null);
    const modal = React.createRef();
    const modalDoc = React.createRef();
    const modalPage = React.createRef();
    const modalData = React.createRef();
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [showLoaderFileIsOpen, setshowLoaderFile] = React.useState(false);
    const [loaderTextFileIsOpen, setloaderTextFile] = React.useState(['']);
    const [clipboardContainerElement, setclipboardContainerElement] = React.useState(false);
    const [UserFiles, setUserFiles] = React.useState(0);
    const [unmount, setunmount] = React.useState(false);
    const [modalFileIsOpen, setFileIsOpen] = React.useState(false);
    const [modalDocIsOpen, setDocIsOpen] = React.useState(false);
    const [modalPageIsOpen, setPageIsOpen] = React.useState(false);
    const [modalDataIsOpen, setDataIsOpen] = React.useState(false);
    const [zoomScale, setzoomScale] = useState('scale(1,1)');
    const [scale, setScale] = useState(1);
    const [klass] = React.useState(null);
    const [EditorDrag, setEditorDrag] = React.useState({x: 0, y: 0});
    const arrLength = props.Pages.length;
    if (tarik.current.length !== arrLength) {
        tarik.current = Array(arrLength).fill().map((_, i) => tarik.current[i] || React.createRef());
    }
    const onClipboardContainerElement = (e) => {
        setclipboardContainerElement(e);
        props.setFooterText(e.footerText);
    }
    const onMouseUp = () => {
        ceren.current.style.cursor = 'auto';
    }
    const onMouseDown = () => {
    }
    const scrollReset = () => {
        if (ceren.current != null)
            ceren.current.scrollTo(0, 0);
    }
    const onMouseMove = (e) => {
        if (e.shiftKey) {
            if (event.buttons == 1 && clipboardContainerElement.EditorMouseDown) {
                ceren.current.scrollTop = ceren.current.scrollTop - (e.clientY - EditorDrag.y);
                ceren.current.scrollLeft = ceren.current.scrollLeft - (e.clientX - EditorDrag.x);
                ceren.current.style.cursor = 'grabbing';
            }
        }
        setEditorDrag({x: e.clientX, y: e.clientY});
    }
    const openModal = () => {
        setIsOpen(true);
        objeler['ElementProps'] = ElementProps;
    }
    const openModalData = () => {
        setDataIsOpen(true);
        objeler['ElementProps'] = ElementProps;
    }
    const openModalDoc = () => {
        setDocIsOpen(true);
        objeler['ElementProps'] = ElementProps;
    }
    const openModalPage = () => {
        setPageIsOpen(true);
        objeler['ElementProps'] = ElementProps;
    }
    const openModalFile = (isDrag) => {
        if (isDrag) {
            objeler['ElementProps'] = ElementProps;
            return;
        }
        setFileIsOpen(true);
        objeler['ElementProps'] = ElementProps;
    }
    const closeModalData = (e) => {
        setDataIsOpen(false);
        if (e === "Cancel") return;
    }
    const closeModalDoc = (e) => {
        setDocIsOpen(false);
        if (e === "Cancel") return;
    }
    const closeModalPage = (e) => {
        // FIX-MP-FOOTER-CFG: PageProperties modal ModalPageValues'a yazıyor,
        // SetPagePreferences ise ModalPageParameters okuyor. Cancel değilse transfer et.
        if (e !== "Cancel" && objeler.ModalPageValues) {
            objeler.ModalPageParameters = {...objeler.ModalPageParameters, ...objeler.ModalPageValues};
        }
        objeler.SetPagePreferences(objeler.ModalPageParameters);
        setPageIsOpen(false);
        if (e === "Cancel") return;
    }
    const closeModalFile = (e) => {
        setFileIsOpen(false);
        // console.log("hangi");
        // console.log(objeler.ModalFileParameters.Type);
        if (e === "Cancel") return;
        if (objeler.ModalFileParameters.Type == 'SaveHtml' || objeler.ModalFileParameters.Type == 'SaveCsHtml') {
            objeler.Editor.SaveHtml(objeler.ModalFileParameters.FileName, objeler.ModalFileParameters.Type == 'SaveCsHtml');
            objeler.ModalFileParameters.IsNew = 0;
        }
        if (objeler.ModalFileParameters.Type == 'Save') {
            objeler.Editor.Save(objeler.ModalFileParameters.FileName, objeler.ModalFileParameters.Pdf);
            objeler.ModalFileParameters.IsNew = 0;
        }
        if (objeler.ModalFileParameters.Type == 'Open') {
            scrollReset();
            objeler.Editor.Open(objeler.ModalFileParameters.FileName);
        }
    }
    const closeModal = (e) => {
        setIsOpen(false);
        if (e === "Cancel") return;
        if (e.Type == 'Barcode') {
            const acr = objeler.ElementProps.Object.properties.size.width / objeler.ElementProps.Object.properties.size.height;
            if (e.BarcodeType == 'QR' && activeElement.properties.BarcodeType != 'QR') {
                objeler.ElementProps.Object.properties.size.height = objeler.ElementProps.Object.properties.size.height * 3;
                objeler.ElementProps.Object.properties.size.width = objeler.ElementProps.Object.properties.size.height;
            }
            if (e.BarcodeType != 'QR' && activeElement.properties.BarcodeType == 'QR') {
                objeler.ElementProps.Object.properties.size.height = objeler.ElementProps.Object.properties.size.height / 3;
            }
        }
        if (objeler.certFile != null) {
            objeler.ElementProps.CertFileName = objeler.certFile.name;
            objeler.ElementProps.CertBlob = window.URL.createObjectURL(objeler.certFile);
            objeler.certFile = null;
        }
        if (objeler.picFile != null) {
            objeler.ElementProps.JpgFileName = objeler.picFile.name;
            objeler.ElementProps.Jpg = objeler.picFile.name;
            objeler.ElementProps.JpgBlob = window.URL.createObjectURL(objeler.picFile);
            objeler.picFile = null;
        }
        activeElement.properties.Text = e.Text;
        // Sync content field with Text so both frontend display and backend use same value
        if (activeElement.type === 'TextBox' && e.Text) {
            activeElement.content = e.Text;
        }
        activeElement.properties.Font = e.Font;
        activeElement.properties.FontFamily = e.FontFamily;
        activeElement.properties.FontSize = e.FontSize;
        activeElement.properties.FontWeight = e.FontWeight;
        activeElement.properties.Bold = e.Bold;
        activeElement.properties.Italic = e.Italic;
        
        // For Table elements, preserve DataSource and Bound if already set in Redux
        if (e.Type === 'Table' && activeElement.properties.DataSource) {
            console.log('🔒 Preserving Table DataSource:', activeElement.properties.DataSource);
            // Keep existing values from Redux, don't override with e
        } else {
            activeElement.properties.Bound = e.Bound;
            activeElement.properties.DataSource = e.DataSource;
        }
        
        activeElement.properties.Continuous = e.Continuous;
        activeElement.properties.Align = e.Align;
        activeElement.properties.CharSpacing = e.CharSpacing;
        activeElement.properties.DataType = e.DataType;
        activeElement.properties.Format = e.Format;
        activeElement.properties.SourceFormat = e.SourceFormat;
        activeElement.properties.Condition = e.Condition;
        activeElement.properties.Calculation = e.Calculation;
        activeElement.properties.CalculationKey = e.CalculationKey;
        activeElement.properties.ConditionKeys = e.ConditionKeys;
        activeElement.properties.Resource = e.Resource;
        activeElement.properties.MLine = e.MLine;
        activeElement.properties.MLineWidth = e.MLineWidth;
        activeElement.properties.Jpg = objeler.ElementProps.Jpg;
        activeElement.properties.JpgPath = objeler.ElementProps.JpgPath;
        activeElement.properties.JpgFileName = e.JpgFileName;
        activeElement.properties.JpgBlob = e.JpgBlob;
        activeElement.properties.JpgOriginalWidth = e.JpgOriginalWidth;
        activeElement.properties.JpgOriginalHeight = e.JpgOriginalHeight;
        activeElement.properties.JpgOriginalAspectRatio = e.JpgOriginalAspectRatio;
        activeElement.properties.CertFileName = e.CertFileName;
        activeElement.properties.CertBlob = e.CertBlob;
        activeElement.properties.CertPath = objeler.ElementProps.CertPath;
        activeElement.properties.Password = e.Password;
        activeElement.properties.ContentState = e.ContentState;
        activeElement.properties.BorderColor = e.BorderColor;
        activeElement.properties.Fill = e.Fill;
        activeElement.properties.FillColor = e.FillColor;
        activeElement.properties.BorderWidth = e.BorderWidth;
        activeElement.properties.BorderStyle = e.BorderStyle;
        activeElement.properties.Direction = e.Direction;
        activeElement.properties.Zindex = e.Zindex;
        activeElement.properties.QREncoding = e.QREncoding;
        activeElement.properties.QRVersion = e.QRVersion;
        activeElement.properties.QRLevel = e.QRLevel;
        activeElement.properties.BarcodeType = e.BarcodeType;
        activeElement.properties.Thickness = e.Thickness;
        activeElement.properties.QRUnicode = e.QRUnicode;
        activeElement.properties.IsScript = e.IsScript;
        activeElement.properties.Script = e.Script;
        e.Object.changeProperties({
            colors: {
                ...activeElement.properties.colors,
                color: e.Color,
                backgroundColor: e.BColor
            }
        });
    }
    var tran = 'scale(1,1)';
    const {tools, activeElement} = props;
    const OpenProperties = (e) => {
        if (e == undefined) return;
        console.log('EEEEE', e)
        var prp = ElementProps;
        prp.Object = e;
        if (prp.Type == 'Slider')
            return;
        objeler["tarik"] = prp;

        openModal();
        handleHideModal();
    }
    const onMouseDownContainer = (e) => {
        objeler.Editor.ContextMenuClose();
        if (e.button == 1) {
            {
                props.ZoomIn(0);
                e.preventDefault();
            }
        }
    }
    const wheel = (e) => {
        objeler.Editor.ContextMenuClose();
        if (e.shiftKey) {
            props.ZoomIn(Math.sign(e.deltaY) * -1);
        }
        return false;
    }
    const handleHideModal = () => {
    }
    const closeMenu = () => {
        setContextMenuState('closed')
    }
    objeler['closeMenu'] = closeMenu;
    objeler['openModalFile'] = openModalFile;
    objeler['closeModalFile'] = closeModalFile;
    objeler['openModalDoc'] = openModalDoc;
    objeler['openModalPage'] = openModalPage;
    objeler['closeModalDoc'] = closeModalDoc;
    objeler['closeModalPage'] = closeModalPage;
    objeler['openModalData'] = openModalData;
    objeler['closeModalData'] = closeModalData;
    // ─── M2: expose GetFiles so setVisibility (in funcs.js) can refresh
    // the document list immediately after a share/unshare action.
    objeler['GetFiles'] = GetFiles;
    // console.log('RENDER', localStorage.getItem("counter"))

    const checksessionStopTimer = () => {
        let i = sessionStorage.getItem("i")
        if (i !== null) {
            let ii = parseInt(i)
            clearInterval(parseInt(i));
            console.log('SES ınt', ii)
            sessionStorage.clear()
        }
    }
    const checksessionTimer = () => {

        let counter = sessionStorage.getItem("counter")
        if (counter !== null) {
            let tmr = parseInt(counter)
            if (tmr > 2) {
                checksession()
                sessionStorage.setItem("counter", 0)
            }
        }
    }
    // checksessionTimer()
    return (
        <div className="w-full flex flex-1 justify-between   "
             style={{width: '100%', position: 'center', alignSelf: 'center'}}
             onMouseDown={(e) => {
                 // console.log('ceriko')
                 setContextMenuState('closed')
             }}
        >
            {props.EditorProps.ShowGridLines && <GridLineStyle GridLines={props.GridLines}/>}
            <div style={{
                zIndex: 555555555555555
            }}
                 rmthumb="1"
                 id="contextmenu"
            >
                <ControlledMenu
                    anchorPoint={AnchorPoint}
                    state={ContextMenuState}
                    onClose={() => setContextMenuState('closed')}
                    onMouseDown={e => e.stopPropagation()}
                    transition={true}
                >
                    <MenuItem className={btnMenuItemClass} onClick={(e) => objeler.Editor.onCopy(e, true)}
                              disabled={activeElement == null}
                    >
                        <table>
                            <tbody>
                            <tr>
                                <td style={{width: btnMenuIconWidth}}>
                                    <i className="fas fa-cut" style={{fontSize: btnMenuIconSize}}/>
                                </td>
                                <td><p className={btnMenuTextClass}>Cut</p></td>
                            </tr>
                            </tbody>
                        </table>
                    </MenuItem>
                    <MenuItem className={btnMenuItemClass} onClick={(e) => objeler.Editor.onCopy(e, false)}
                              disabled={activeElement == null || activeElement.type == 'Signature'}
                    >
                        <table>
                            <tbody>
                            <tr>
                                <td style={{width: btnMenuIconWidth}}>
                                    <i className="fas fa-copy" style={{fontSize: btnMenuIconSize}}/>
                                </td>
                                <td><p className={btnMenuTextClass}>Copy</p></td>
                            </tr>
                            </tbody>
                        </table>
                    </MenuItem>
                    <MenuItem className={btnMenuItemClass}
                              disabled={clipboardContainerElement.element == null}
                              onClick={(e) => objeler.Editor.onPaste(e)}>
                        <table>
                            <tbody>
                            <tr>
                                <td style={{width: btnMenuIconWidth}}>
                                    <i className="fas fa-paste  " style={{fontSize: btnMenuIconSize}}/>
                                </td>
                                <td><p className={btnMenuTextClass}>Paste</p></td>
                            </tr>
                            </tbody>
                        </table>
                    </MenuItem>
                    <MenuDivider/>
                    <MenuItem className={btnMenuItemClass} onClick={(e) => objeler.Editor.onBringToFront(e)}
                              disabled={activeElement == null}
                    >
                        <table>
                            <tbody>
                            <tr>
                                <td style={{width: btnMenuIconWidth}}>
                                    <i className="fas fa-bring-front" style={{fontSize: btnMenuIconSize}}/>
                                </td>
                                <td><p className={btnMenuTextClass}>Bring to Front</p></td>
                            </tr>
                            </tbody>
                        </table>
                    </MenuItem>
                    <MenuItem className={btnMenuItemClass} onClick={(e) => objeler.Editor.onSendToBack(e)}
                              disabled={activeElement == null}
                    >
                        <table>
                            <tbody>
                            <tr>
                                <td style={{width: btnMenuIconWidth}}>
                                    <i className="fas fa-send-back" style={{fontSize: btnMenuIconSize}}/>
                                </td>
                                <td><p className={btnMenuTextClass}>Send to Back</p></td>
                            </tr>
                            </tbody>
                        </table>
                    </MenuItem>
                    <MenuDivider/>
                    <MenuItem className={btnMenuItemClass}
                              disabled={activeElement == null}
                              onClick={(e) => {
                                  objeler.doubleClick();
                              }}>
                        <table>
                            <tbody>
                            <tr>
                                <td style={{width: btnMenuIconWidth}}>
                                    <i className="fas fa-hammer" style={{fontSize: btnMenuIconSize}}/>
                                </td>
                                <td><p className={btnMenuTextClass}>Properties</p></td>
                            </tr>
                            </tbody>
                        </table>
                    </MenuItem>
                    <MenuDivider/>
                    <SubMenu label="Page"
                             itemClassName={btnSubMenuClass}
                             itemStyles={{backgroundColor: 'white', hover: {backgroundColor: '#EFF6FF'}}}
                    >
                        <MenuItem className={btnSubMenuItemClass}
                                  onClick={props.NewPageClick}>
                            <table>
                                <tbody>
                                <tr>
                                    <td style={{width: btnMenuIconWidth}}>
                                        <i className="fas fa-file-alt" style={{fontSize: btnMenuIconSize}}/>
                                    </td>
                                    <td><p className={btnMenuTextClass}>Add Page</p></td>
                                </tr>
                                </tbody>
                            </table>
                        </MenuItem>
                        <MenuItem className={btnSubMenuItemClass}
                                  onClick={props.InsertPageClick}>
                            <table>
                                <tbody>
                                <tr>
                                    <td style={{width: btnMenuIconWidth}}>
                                        <i className="fas fa-file-import" style={{fontSize: btnMenuIconSize}}/>
                                    </td>
                                    <td><p className={btnMenuTextClass}>Insert Page</p></td>
                                </tr>
                                </tbody>
                            </table>
                        </MenuItem>
                        <MenuItem className={btnSubMenuItemClass}
                                  onClick={(e) => props.DeletePageClick(MenuActionPageId)}>
                            <table>
                                <tbody>
                                <tr>
                                    <td style={{width: btnMenuIconWidth}}>
                                        <i className="fas fa-trash-alt" style={{fontSize: btnMenuIconSize}}/>
                                    </td>
                                    <td><p className={btnMenuTextClass}>Delete Page</p></td>
                                </tr>
                                </tbody>
                            </table>
                        </MenuItem>
                        <MenuDivider/>
                        <MenuItem className={btnSubMenuItemClass}
                                  onClick={(e) => objeler.Editor.openPageDialog(MenuActionPageId)}>
                            <table>
                                <tbody>
                                <tr>
                                    <td style={{width: btnMenuIconWidth}}>
                                        <i className="fas fa-hammer" style={{fontSize: btnMenuIconSize}}/>
                                    </td>
                                    <td><p className={btnMenuTextClass}>Preferences</p></td>
                                </tr>
                                </tbody>
                            </table>
                        </MenuItem>
                    </SubMenu>
                </ControlledMenu>
            </div>
            <table style={{width: '100%'}}>
                <tbody>
                <tr style={{verticalAlign: 'top'}}>
                    <td style={{width: '20%'}} rmthumb="1">
                        <div className="w-full"
                             style={{
                                 display: 'flex', justifyContent: 'flex-end'
                             }}
                        >
                            <Toolbox tools={tools}
                                     minWidth={'200px'}
                                     maxWidth={'200px'}
                                     EditorPropsChange={props.EditorPropsChange}
                                     EditorProps={props.EditorProps}
                                     Pages={props.Pages}
                            />
                        </div>
                    </td>
                    <td style={{width: '82%'}}>
                        <div className="bg-grday-50 shadow-inner p-3 w-full overflow-y-scroll"
                             style={{
                                 overflowy: 'scroll',
                                 height: window.innerHeight - 80,
                                 width: '100%',
                                 justifyContent: 'center',
                                 display: 'flex',
                                 flexDirection: 'column'
                                 ,
                                 alignItems: 'center'
                             }}
                             ref={ceren}
                             id='ceren'
                             onWheel={wheel}
                             onMouseDown={onMouseDownContainer}
                             onScroll={() => {
                                 for (let abc in props.Pages) {
                                     let prop = props.Pages.length - abc - 1;
                                     let topmargin = tarik.current[0].current.getBoundingClientRect().top - tarik.current[0].current.parentElement.getBoundingClientRect().top;
                                     if (tarik.current[prop].current.getBoundingClientRect().top - (topmargin * 1.5) <
                                         ((tarik.current[prop].current.parentElement.parentElement.getBoundingClientRect().bottom - tarik.current[prop].current.parentElement.parentElement.getBoundingClientRect().top) / 2)
                                     ) {
                                         props.onChangeActivePageScroll(prop + 1)
                                         break;
                                     }
                                 }
                             }}
                        >
                            <div className="bg-grey-lightest  p-3 w-full  " id="zoomDiv"
                                 style={{
                                     height: (window.innerHeight - 48) / 1,
                                     transform: props.zoomScale,
                                     transformOrigin: '0 0'
                                 }}
                            >
                                {props.Pages.map((b, i) => (
                                    <Editor key={"edt_" + b.id} tarik={tarik.current[i]} width={b.width}
                                            height={b.height}
                                            OpenProperties={e => OpenProperties(e)}
                                            zoomScaleprop={"edt_" + b.id}
                                            scaleNumber={props.scaleNumber}
                                            pageid={b.id}
                                            pages={props.Pages}
                                            page={b}
                                            clipboardContainerElement={e => onClipboardContainerElement(e)}
                                            clipboardContainerElementValue={clipboardContainerElement}
                                            onMouseEnter={(e) => {
                                                props.onChangeActivePage(e)
                                            }}
                                            onMouseMove={e => onMouseMove(e)}
                                            onMouseDown={e => onMouseDown(e)}
                                            onMouseUp={e => onMouseUp(e)}
                                            AddNewPage={props.NewPageClick}
                                            InsertNewPage={props.InsertPageClick}
                                            DeletePageClick={props.DeletePageClick}
                                            activePage={props.activePage}
                                            RefreshFileExplorer={e => RefreshFileExplorer(e)}
                                            ResetPage={props.ResetPage}
                                            ScrollReset={e => scrollReset(e)}
                                            ShowLoader={(e, text) => props.ShowLoader(e, text)}
                                            ShowLoaderAllClose={e => ShowLoaderAllClose()}
                                            EditorProps={props.EditorProps}
                                            GridLines={props.GridLines}
                                            GridSize={props.GridSize}
                                            IsModalOpen={modalFileIsOpen || modalDocIsOpen || modalPageIsOpen || modalDataIsOpen || modalIsOpen}
                                            setContextMenuState={(e) => {
                                                setContextMenuState(e)
                                            }}
                                            ContextMenuState={ContextMenuState}
                                            setAnchorPoint={(e) => {
                                                setAnchorPoint(e)
                                            }}
                                            AnchorPoint={AnchorPoint}
                                            setMenuActionPageId={(e) => {
                                                setMenuActionPageId(e)
                                            }}
                                            MenuActionPageId={MenuActionPageId}
                                    />
                                ))}
                            </div>
                        </div>
                        <ModalDialogFile
                            ref={modal}
                            isOpen={modalFileIsOpen}
                            closeModal={e => closeModalFile(e)}
                            ElementProps={ElementProps}>
                        </ModalDialogFile>
                        <ModalDialogDoc
                            ref={modalDoc}
                            isOpen={modalDocIsOpen}
                            closeModal={e => closeModalDoc(e)}
                            ElementProps={ElementProps}
                            DocProps={props.Doc}>
                        </ModalDialogDoc>
                        <ModalDialogPage
                            ref={modalPage}
                            isOpen={modalPageIsOpen}
                            closeModal={e => closeModalPage(e)}
                            ElementProps={ElementProps}
                            DocProps={props.Doc}>
                        </ModalDialogPage>
                        <ModalDialogData
                            ref={modalData}
                            isOpen={modalDataIsOpen}
                            closeModal={e => closeModalData(e)}
                            ElementProps={ElementProps}
                            DocProps={props.Doc}>
                        </ModalDialogData>
                        <ModalDialog
                            ref={modal}
                            isOpen={modalIsOpen}
                            closeModal={e => closeModal(e)}
                            ElementProps={ElementProps}>
                        </ModalDialog>
                    </td>
                    <td style={{width: '18%'}} rmthumb="1">
                        { !(objeler.hasOwnProperty("User") && objeler.User.hasOwnProperty("From") && objeler.User.From === "Direct") &&
                            <ToolboxFileExplorer tools={objeler.userFiles}
                                             user={objeler.User}
                                             minWidth={'200px'}
                                             maxWidth={'200px'}
                                             ShowLoaderFile={showLoaderFileIsOpen}
                                             DeleteFile={e => DeleteFile(e)}
                        />}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
}